export enum AktionTypeEnum {
    BLOG = "blog",
    FORUM = "forum",
    LINK = "link",
    LINK_INTERN = "link-intern",
    LINK_SETTINGS = "link-settings",
    NACHRICHT = "nachricht",
    TYPEBOT = "typebot",
    WIKI = "wiki",
}
